module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero-accordion"
  }, [_c('div', {
    staticClass: "hero-accordion__card"
  }, [_c('div', {
    staticClass: "hero-accordion__card-header"
  }, [_c('h1', [_vm._v(_vm._s(_vm.content.hero.accordion_collapse.header_lg))]), _c('h2', [_vm._v(_vm._s(_vm.content.hero.accordion_collapse.header_sm))])]), _c('h3', [_vm._v(_vm._s(_vm.content.hero.accordion_collapse.text))]), _c('div', {
    staticClass: "hero-accordion__card-btn",
    on: {
      "click": _vm.openAccordion
    }
  }, [_c('Icon', {
    attrs: {
      "name": "chevron-left"
    }
  }), _vm._v("More Info       ")], 1)]), (_vm.show) ? _c('div', {
    staticClass: "hero-accordion__content"
  }, [_vm._l((_vm.content.hero.accordion_expand.content), function(item) {
    return _c('div', {
      staticClass: "hero-accordion__content-container"
    }, [_c('div', {
      staticClass: "hero-accordion__content-title"
    }, [_vm._v(_vm._s(item.title))]), _c('div', {
      staticClass: "hero-accordion__content-text",
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    }, [_vm._v(_vm._s(item.text))])])
  }), _c('div', {
    staticClass: "hero-accordion__content-border"
  })], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-192998a7"}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-accordion-hero/custom-accordion-hero.pug
// module id = 497
// module chunks = 1